var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.accountsEnabled)?_c('div',{staticClass:"account-icon-container"},[_c('a',{attrs:{"href":"/account"}},[_c('icon',{attrs:{"name":"account","size":"24px"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }